var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef, Fragment, useEffect } from "react";
import { StyledTabs, StyledTabsWrapper } from "./styled";
import { useBuildTabs, useSetActive } from "./tabs-hooks";
export var Tabs = forwardRef(function (_a, ref) {
    var className = _a.className, onChange = _a.onChange, selected = _a.selected, children = _a.children, _b = _a.TabsHeader, TabsHeader = _b === void 0 ? Fragment : _b, _c = _a.TabContent, TabContent = _c === void 0 ? Fragment : _c, noDefaultBorder = _a.noDefaultBorder, rest = __rest(_a, ["className", "onChange", "selected", "children", "TabsHeader", "TabContent", "noDefaultBorder"]);
    var _d = useSetActive(selected, onChange), activeIndex = _d[0], setActiveIndex = _d[1];
    var _e = useBuildTabs(children, activeIndex, setActiveIndex), nav = _e[0], content = _e[1], firstActiveIndex = _e[2], activeIsDisabled = _e[3];
    useEffect(function () {
        if (activeIsDisabled && activeIndex !== firstActiveIndex)
            setActiveIndex(firstActiveIndex);
    }, [activeIndex, firstActiveIndex, activeIsDisabled, setActiveIndex]);
    return (React.createElement(StyledTabsWrapper, __assign({ className: className }, rest),
        React.createElement(TabsHeader, { ref: ref },
            React.createElement(StyledTabs, { className: "tabs", noDefaultBorder: noDefaultBorder }, nav)),
        React.createElement(TabContent, null, content)));
});
